import React, { useState, useEffect, useRef } from 'react';
import logo from '../logo_blade.png';
import { db } from '../services/firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

const meses = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho','Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];
const diasSemana = ['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'];

// Gera todos os slots de 30 em 30 min para 24h
function gerarSlots() {
  const slots = [];
  for (let h = 0; h <= 23; h++) {
    slots.push(`${String(h).padStart(2,'0')}:00`);
    slots.push(`${String(h).padStart(2,'0')}:30`);
  }
  return slots;
}
const TODOS_SLOTS = gerarSlots();

function getDiasDoMes(mesNome) {
  const ano = new Date().getFullYear();
  const mesIdx = meses.indexOf(mesNome);
  const totalDias = new Date(ano, mesIdx + 1, 0).getDate();
  const offset = new Date(ano, mesIdx, 1).getDay();
  return { totalDias, offset, mesIdx };
}

// Retorna os slots do barbeiro para um dia específico da semana (ex: 'Seg')
function getSlotsParaDia(barbeiro, diaSemana) {
  const hp = barbeiro?.horariosPorDia;
  // Novo formato: horariosPorDia
  if (hp && hp[diaSemana]) {
    const periodos = hp[diaSemana];
    return TODOS_SLOTS.filter(slot => {
      const [hh, mm] = slot.split(':').map(Number);
      const mins = hh * 60 + mm;
      return periodos.some(p => {
        const ini = p.inicio.split(':').map(Number);
        const fim = p.fim.split(':').map(Number);
        const iniMins = ini[0] * 60 + ini[1];
        const fimMins = fim[0] * 60 + fim[1];
        return mins >= iniMins && mins <= fimMins;
      });
    });
  }
  // Formato legado: horaInicio / horaFim
  if (barbeiro?.horaInicio && barbeiro?.horaFim) {
    const [ih, im] = barbeiro.horaInicio.split(':').map(Number);
    const [fh, fm] = barbeiro.horaFim.split(':').map(Number);
    const iniMins = ih * 60 + im;
    const fimMins = fh * 60 + fm;
    return TODOS_SLOTS.filter(h => {
      const [hh, mm] = h.split(':').map(Number);
      const mins = hh * 60 + mm;
      return mins >= iniMins && mins <= fimMins;
    });
  }
  // Fallback: 08:00–19:30
  return TODOS_SLOTS.filter(h => {
    const [hh] = h.split(':').map(Number);
    return hh >= 8 && hh < 20;
  });
}

// Normaliza promoção dos formatos antigo (campo único com `tipo`) e novo (sub-objetos por tipo)
function getPromocoes(barbearia) {
  const p = barbearia?.promocao || {};
  // Novo formato: tem sub-objetos por tipo
  if (p.simples !== undefined || p.dias !== undefined || p.fidelidade !== undefined) {
    return {
      simples:    p.simples    || { ativa: false, desconto: 0, texto: '' },
      dias:       p.dias       || { ativa: false, desconto: 0, diasSemana: [], texto: '' },
      fidelidade: p.fidelidade || { ativa: false, fidelidadeMeta: 10, texto: '' },
    };
  }
  // Formato legado: objeto único com campo `tipo`
  if (p.ativa) {
    const tipo = p.tipo || 'simples';
    return {
      simples:    tipo === 'simples'    ? { ativa: true, desconto: p.desconto || 0, texto: p.texto || '' }                              : { ativa: false, desconto: 0, texto: '' },
      dias:       tipo === 'dias'       ? { ativa: true, desconto: p.desconto || 0, diasSemana: p.diasSemana || [], texto: p.texto || '' } : { ativa: false, desconto: 0, diasSemana: [], texto: '' },
      fidelidade: tipo === 'fidelidade' ? { ativa: true, fidelidadeMeta: p.fidelidadeMeta || 10, texto: p.texto || '' }                  : { ativa: false, fidelidadeMeta: 10, texto: '' },
    };
  }
  return {
    simples:    { ativa: false, desconto: 0, texto: '' },
    dias:       { ativa: false, desconto: 0, diasSemana: [], texto: '' },
    fidelidade: { ativa: false, fidelidadeMeta: 10, texto: '' },
  };
}

function Horarios({ barbeiro, barbearia, editando, onVoltar, onConfirmar, onInicio }) {
  const hoje = new Date(new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" }));
  const nomeMesHoje = meses[hoje.getMonth()];
  const diaHoje = String(hoje.getDate()).padStart(2, '0');
  const horaAtual = hoje.getHours();
  const minAtual = hoje.getMinutes();

  // Modo "Todos os barbeiros"
  const todosMode = barbeiro?.todos === true;
  const barbeirosAll = todosMode
    ? (barbearia?.barbeiros || []).filter(b => !b.oculto)
    : [];

  // Em modo edição, abre já no mês/dia do agendamento original
  const mesInicial = (editando?.mes && meses.includes(editando.mes)) ? editando.mes : nomeMesHoje;
  const diaInicial = editando?.dia || diaHoje;

  const [mesAtivo, setMesAtivo] = useState(mesInicial);
  const [diaSelected, setDiaSelected] = useState(diaInicial);
  const [horarioSelected, setHorarioSelected] = useState(null);
  const [servicoSelected, setServicoSelected] = useState(0);
  // Barbeiro auto-atribuído ao selecionar slot no modo todos
  const [barbeiroAssigned, setBarbeiroAssigned] = useState(null);

  const horariosRef = useRef(null);
  const servicosRef = useRef(null);
  // Garantem que a pré-seleção de edição rode só uma vez (não atrapalha trocas manuais)
  const horarioEditAplicado = useRef(false);
  const servicoEditAplicado = useRef(false);

  // Promoções normalizadas (compatível com formato antigo e novo)
  const { simples: promoSimples, dias: promoDias } = getPromocoes(barbearia);

  // Mapa: { [nomeBarbeiro]: [slotsOcupados] } — usado nos dois modos
  const [ocupadosPorBarbeiro, setOcupadosPorBarbeiro] = useState({});

  useEffect(() => {
    if (!barbearia?.id) return;
    setOcupadosPorBarbeiro({});
    getDocs(
      query(collection(db, 'agendamentos'), where('barbeariaId', '==', barbearia.id))
    ).then(snap => {
      const docs = snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .filter(a =>
          a.dia === diaSelected &&
          (a.mes === mesAtivo || !a.mes) &&
          a.status !== 'cancelado' &&
          // Em edição, o próprio slot atual do cliente não conta como ocupado —
          // assim ele pode manter o mesmo horário e só trocar serviço/barbeiro.
          a.id !== editando?.id
        );
      const mapa = {};
      const nomes = todosMode ? barbeirosAll.map(b => b.nome) : [barbeiro?.nome];
      nomes.forEach(nome => {
        mapa[nome] = docs.filter(a => a.barbeiro === nome).map(a => a.horario);
      });
      setOcupadosPorBarbeiro(mapa);
    }).catch(e => console.error('Horarios ocupados:', e));
  }, [diaSelected, mesAtivo, barbeiro?.nome, barbearia?.id, todosMode]); // eslint-disable-line react-hooks/exhaustive-deps

  // Compatibilidade com modo single
  const horariosOcupados = todosMode ? [] : (ocupadosPorBarbeiro[barbeiro?.nome] || []);

  // Dia da semana do agendamento selecionado
  const diaSemanaAgendamento = (() => {
    const { mesIdx: mIdx } = getDiasDoMes(mesAtivo);
    return new Date(new Date().getFullYear(), mIdx, parseInt(diaSelected)).getDay();
  })();
  const ehDiaEspecial = promoDias.ativa && (promoDias.diasSemana || []).includes(diaSemanaAgendamento);

  // Desconto efetivo para o dia selecionado:
  // - Fidelidade desabilitada por enquanto (em desenvolvimento)
  // - Dias especiais: usa desconto de dias
  // - Outros dias: usa desconto direto (simples), se ativo
  // - Os dois NÃO são cumulativos
  const desconto = (() => {
    if (ehDiaEspecial) return promoDias.desconto || 0;
    if (promoSimples.ativa) return promoSimples.desconto || 0;
    return 0;
  })();

  function aplicarDesconto(precoStr) {
    if (!desconto || !precoStr) return precoStr;
    if (desconto === 100) return 'R$ 0,00';
    const num = parseFloat(precoStr.toString().replace(/[^\d.,]/g, '').replace(',', '.')) || 0;
    const desc = Math.round(num * (1 - desconto / 100) * 100) / 100;
    return 'R$ ' + desc.toFixed(2).replace('.', ',');
  }

  const servicosBase = barbearia?.servicos?.length > 0
    ? barbearia.servicos
    : [
        { nome: 'Corte + Barba', preco: 'R$ 75,00', duracao: '60 min' },
        { nome: 'Só o Corte',    preco: 'R$ 50,00', duracao: '40 min' },
        { nome: 'Só a Barba',    preco: 'R$ 45,00', duracao: '30 min' },
      ];
  const servicos = servicosBase.map(s => ({
    ...s,
    precoOriginal: s.preco,
    preco: aplicarDesconto(s.preco),
  }));

  const { totalDias, offset, mesIdx } = getDiasDoMes(mesAtivo);
  const mesIdxHoje = meses.indexOf(nomeMesHoje);

  // Limite máximo: 90 dias a partir de hoje
  const dataLimite = new Date(hoje);
  dataLimite.setDate(dataLimite.getDate() + 90);
  // Mês+ano do limite como número comparável (ex: 2026*12 + 3 = 24315)
  const mesLimiteIdx = dataLimite.getFullYear() * 12 + dataLimite.getMonth();
  const mesAtivoIdx = hoje.getFullYear() * 12 + mesIdx;

  function isPast90(numDia) {
    const ano = hoje.getFullYear();
    const dt = new Date(ano, mesIdx, parseInt(numDia));
    return dt > dataLimite;
  }

  function getSlotsDoDia(numDia) {
    const ano = hoje.getFullYear();
    const dt = new Date(ano, mesIdx, parseInt(numDia));
    const nomeDiaSemana = diasSemana[dt.getDay()];
    if (todosMode) {
      const allSlots = new Set();
      barbeirosAll.forEach(b => getSlotsParaDia(b, nomeDiaSemana).forEach(s => allSlots.add(s)));
      return [...allSlots].sort();
    }
    return getSlotsParaDia(barbeiro, nomeDiaSemana);
  }

  function barberoPodeNoDia(numDia) {
    const ano = hoje.getFullYear();
    const dt = new Date(ano, mesIdx, parseInt(numDia));
    const nomeDiaSemana = diasSemana[dt.getDay()];
    if (todosMode) {
      return barbeirosAll.some(b => {
        const hp = b?.horariosPorDia;
        if (hp) return hp[nomeDiaSemana] && hp[nomeDiaSemana].length > 0;
        const dias = b?.diasTrabalho?.length > 0 ? b.diasTrabalho : ['Seg','Ter','Qua','Qui','Sex','Sáb'];
        return dias.includes(nomeDiaSemana);
      });
    }
    const hp = barbeiro?.horariosPorDia;
    if (hp) {
      return hp[nomeDiaSemana] && hp[nomeDiaSemana].length > 0;
    }
    const diasTrabalho = barbeiro?.diasTrabalho?.length > 0
      ? barbeiro.diasTrabalho
      : ['Seg','Ter','Qua','Qui','Sex','Sáb'];
    return diasTrabalho.includes(nomeDiaSemana);
  }

  // Retorna barbeiros disponíveis para um slot em modo todos
  function getBarbeirosDisponiveis(slot) {
    const ano = hoje.getFullYear();
    const dt = new Date(ano, mesIdx, parseInt(diaSelected));
    const nomeDiaSemana = diasSemana[dt.getDay()];
    return barbeirosAll.filter(b => {
      const slots = getSlotsParaDia(b, nomeDiaSemana);
      if (!slots.includes(slot)) return false;
      const ocupados = ocupadosPorBarbeiro[b.nome] || [];
      return !ocupados.includes(slot);
    });
  }

  function getDiasTrabalhoExibicao() {
    const hp = barbeiro?.horariosPorDia;
    if (hp) return Object.keys(hp).filter(d => hp[d]?.length > 0);
    return barbeiro?.diasTrabalho?.length > 0
      ? barbeiro.diasTrabalho
      : ['Seg','Ter','Qua','Qui','Sex','Sáb'];
  }

  function isPastDay(numDia) {
    if (mesIdx < mesIdxHoje) return true;
    if (mesIdx > mesIdxHoje) return false;
    return parseInt(numDia) < parseInt(diaHoje);
  }

  function isDiaDisponivel(numDia) {
    return !isPastDay(numDia) && !isPast90(numDia) && barberoPodeNoDia(numDia);
  }

  function isPastTime(h, dia, mes) {
    const d = dia || diaSelected;
    const m = mes || mesAtivo;
    if (d !== diaHoje || m !== nomeMesHoje) return false;
    const [hh, mm] = h.split(':').map(Number);
    return hh < horaAtual || (hh === horaAtual && mm <= minAtual);
  }

  function primeiroHorarioDisponivel(dia, mes) {
    const slots = getSlotsDoDia(dia);
    return slots.find(h => !isPastTime(h, dia, mes)) || null;
  }

  useEffect(() => {
    if (isDiaDisponivel(diaSelected)) {
      // Em edição: na 1ª vez, mantém o horário original selecionado se for deste dia,
      // do mesmo barbeiro e ainda não passou. Depois disso, comportamento normal.
      const manterOriginal = editando && !horarioEditAplicado.current
        && (todosMode || barbeiro?.nome === editando.barbeiro)
        && editando.dia === diaSelected && editando.mes === mesAtivo
        && getSlotsDoDia(diaSelected).includes(editando.horario)
        && !isPastTime(editando.horario, diaSelected, mesAtivo);
      setHorarioSelected(manterOriginal ? editando.horario : primeiroHorarioDisponivel(diaSelected, mesAtivo));
    } else {
      setHorarioSelected(null);
    }
    horarioEditAplicado.current = true;
  }, [diaSelected, mesAtivo]); // eslint-disable-line react-hooks/exhaustive-deps

  // Pré-seleciona o serviço do agendamento original (uma vez), quando estiver editando
  useEffect(() => {
    if (editando && !servicoEditAplicado.current && servicos.length > 0) {
      const idx = servicos.findIndex(s => s.nome === editando.servico);
      if (idx >= 0) setServicoSelected(idx);
      servicoEditAplicado.current = true;
    }
  }, [editando, servicos]); // eslint-disable-line react-hooks/exhaustive-deps

  function selecionarDia(num) {
    if (!isDiaDisponivel(num)) return;
    setDiaSelected(num);
    setTimeout(() => {
      horariosRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  function selecionarHorario(h) {
    if (isPastTime(h)) return;
    setHorarioSelected(h);
    if (todosMode) {
      const disponiveis = getBarbeirosDisponiveis(h);
      setBarbeiroAssigned(disponiveis[0] || null);
    }
    setTimeout(() => {
      servicosRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  function renderCalendario() {
    const cells = [];
    for (let i = 0; i < offset; i++) {
      cells.push(<div key={`empty-${i}`} />);
    }
    for (let d = 1; d <= totalDias; d++) {
      const num = String(d).padStart(2, '0');
      const passado = isPastDay(num);
      const alem90 = !passado && isPast90(num);
      const semTurno = !passado && !alem90 && !barberoPodeNoDia(num);
      const isHoje = num === diaHoje && mesAtivo === nomeMesHoje;
      const isAtivo = diaSelected === num;
      const indisponivel = passado || alem90 || semTurno;

      let bg = '#181818';
      let border = '#252525';
      let corNum = '#888';

      if (indisponivel) {
        bg = '#111';
        border = '#1a1a1a';
        corNum = '#252525';
      } else if (isAtivo) {
        bg = '#1a2a1a';
        border = '#3d6b3d';
        corNum = '#7bc47b';
      } else if (isHoje) {
        bg = '#1a1508';
        border = '#c9a84c';
        corNum = '#c9a84c';
      }

      cells.push(
        <div
          key={num}
          onClick={() => selecionarDia(num)}
          style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center',
            justifyContent: 'center', padding: '4px 2px',
            backgroundColor: bg,
            border: `0.5px solid ${border}`,
            borderRadius: '8px',
            cursor: indisponivel ? 'default' : 'pointer',
            minHeight: '34px',
            position: 'relative'
          }}
        >
          <span style={{ fontSize: '11px', color: corNum, fontWeight: isAtivo || isHoje ? '700' : '400' }}>
            {d}
          </span>
          {isAtivo && (
            <div style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#7bc47b', marginTop: '2px' }} />
          )}
          {isHoje && !isAtivo && (
            <div style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#c9a84c', marginTop: '2px' }} />
          )}
          {semTurno && (
            <div style={{ fontSize: '7px', color: '#333', marginTop: '1px' }}>—</div>
          )}
        </div>
      );
    }
    return cells;
  }

  const barbeiroPodeHoje = barberoPodeNoDia(diaSelected);
  const horariosBarb = getSlotsDoDia(diaSelected);
  const diasTrabalho = getDiasTrabalhoExibicao();
  const servicoAtual = servicos[servicoSelected];
  const barbeiroParaConfirmar = todosMode ? barbeiroAssigned : barbeiro;

  return (
    <div style={{ backgroundColor: '#0f0f0f', minHeight: '100vh', fontFamily: 'Arial, sans-serif', color: '#e8e8e8' }}>

      {/* Cabeçalho */}
      <div style={{
        padding: '16px 20px', borderBottom: '1px solid #1a1a1a',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        position: 'sticky', top: 0, backgroundColor: '#0f0f0f', zIndex: 10
      }}>
        <span onClick={onVoltar} style={{ fontSize: '22px', color: '#b6b6b6', cursor: 'pointer' }}>‹</span>
        <img src={logo} alt="BLADE" style={{ height: '30px', cursor: 'pointer' }} onClick={() => onInicio && onInicio()} />
        <span style={{ width: '22px' }} />
      </div>

      {/* Perfil do barbeiro */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '14px',
        padding: '14px 20px', borderBottom: '1px solid #1a1a1a'
      }}>
        <div style={{
          width: '52px', height: '52px', borderRadius: '50%',
          backgroundColor: '#1e2e1e', border: '2px solid #2d4a2d',
          flexShrink: 0, overflow: 'hidden',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          {todosMode ? (
            <span style={{ fontSize: '22px' }}>✂️</span>
          ) : barbeiro?.foto ? (
            <img src={barbeiro.foto} alt={barbeiro.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => e.target.style.display='none'} />
          ) : (
            <svg width="26" height="26" viewBox="0 0 36 36" fill="none">
              <path d="M18 4C14 4 11 7 11 11C11 15 14 18 18 18C22 18 25 15 25 11C25 7 22 4 18 4Z" fill="#3a3a3a"/>
              <path d="M8 8L12 14M28 8L24 14" stroke="#7bc47b" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          )}
        </div>
        <div>
          <div style={{ fontSize: '16px', fontWeight: '700', marginBottom: '2px' }}>
            {todosMode ? 'Qualquer barbeiro' : (barbeiro?.nome || 'Barbeiro')}
          </div>
          {todosMode ? (
            <div style={{ fontSize: '11px', color: '#8f8f8f', marginTop: '2px' }}>
              {barbeirosAll.length} barbeiro{barbeirosAll.length !== 1 ? 's' : ''} disponível{barbeirosAll.length !== 1 ? 'veis' : ''}
            </div>
          ) : (
            <>
              <div style={{ fontSize: '12px', color: '#c9a84c' }}>
                ★★★★★ <span style={{ color: '#8f8f8f' }}>{barbeiro?.avaliacao || '5.0'}</span>
              </div>
              {diasTrabalho.length > 0 && (
                <div style={{ fontSize: '11px', color: '#8f8f8f', marginTop: '3px' }}>
                  {diasTrabalho.join(', ')}
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <div style={{ padding: '16px 20px' }}>

        {/* Banner de edição */}
        {editando && (
          <div style={{ backgroundColor: '#1a1508', border: '0.5px solid #c9a84c', borderRadius: '12px', padding: '10px 14px', marginBottom: '14px' }}>
            <div style={{ fontSize: '12px', color: '#c9a84c', fontWeight: '700', marginBottom: '2px' }}>✏️ Editando agendamento</div>
            <div style={{ fontSize: '11px', color: '#b6b6b6', lineHeight: '1.5' }}>
              Mantenha o mesmo horário e só troque o serviço, ou escolha um novo dia/horário. As alterações só valem ao salvar.
            </div>
          </div>
        )}

        {/* Seletor de mês */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
          <span
            onClick={() => {
              if (mesAtivoIdx > mesIdxHoje) {
                const novoMesIdx = (mesIdx - 1 + 12) % 12;
                const novoMes = meses[novoMesIdx];
                setMesAtivo(novoMes);
                setDiaSelected(novoMes === nomeMesHoje ? diaHoje : '01');
              }
            }}
            style={{
              fontSize: '20px',
              color: mesAtivoIdx > mesIdxHoje ? '#7bc47b' : '#333',
              cursor: mesAtivoIdx > mesIdxHoje ? 'pointer' : 'default',
              padding: '0 8px'
            }}>‹</span>
          <span style={{ fontSize: '14px', fontWeight: '600', color: '#e8e8e8' }}>{mesAtivo}</span>
          <span
            onClick={() => {
              if (mesAtivoIdx < mesLimiteIdx) { setMesAtivo(meses[(mesIdx + 1) % 12]); setDiaSelected('01'); }
            }}
            style={{ fontSize: '20px', color: mesAtivoIdx < mesLimiteIdx ? '#7bc47b' : '#333', cursor: mesAtivoIdx < mesLimiteIdx ? 'pointer' : 'default', padding: '0 8px' }}>›</span>
        </div>

        {/* Cabeçalho dias da semana */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px', marginBottom: '4px' }}>
          {diasSemana.map(d => (
            <div key={d} style={{ textAlign: 'center', fontSize: '10px', color: '#7d7d7d', padding: '4px 0' }}>{d}</div>
          ))}
        </div>

        {/* Grid de dias */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '4px', marginBottom: '8px' }}>
          {renderCalendario()}
        </div>

        {/* Legenda */}
        <div style={{ display: 'flex', gap: '14px', marginBottom: '12px', flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '2px', backgroundColor: '#1a1508', border: '0.5px solid #c9a84c' }} />
            <span style={{ fontSize: '10px', color: '#7d7d7d' }}>Hoje</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '2px', backgroundColor: '#1a2a1a', border: '0.5px solid #3d6b3d' }} />
            <span style={{ fontSize: '10px', color: '#7d7d7d' }}>Selecionado</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
            <div style={{ width: '8px', height: '8px', borderRadius: '2px', backgroundColor: '#111', border: '0.5px solid #1a1a1a' }} />
            <span style={{ fontSize: '10px', color: '#7d7d7d' }}>Indisponível</span>
          </div>
        </div>

        {/* Horários */}
        <div ref={horariosRef} style={{ fontSize: '10px', letterSpacing: '2px', color: '#7d7d7d', textTransform: 'uppercase', marginBottom: '10px' }}>
          Horários — {diasSemana[new Date(hoje.getFullYear(), mesIdx, parseInt(diaSelected)).getDay()]}, {parseInt(diaSelected)} de {mesAtivo}
        </div>

        {!barbeiroPodeHoje ? (
          <div style={{ backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '10px', padding: '20px', textAlign: 'center', marginBottom: '24px' }}>
            <div style={{ fontSize: '24px', marginBottom: '8px' }}>🗓</div>
            <div style={{ fontSize: '13px', color: '#8f8f8f' }}>
              {todosMode ? 'Nenhum barbeiro trabalha neste dia' : `${barbeiro?.nome?.split(' ')[0] || 'Barbeiro'} não trabalha neste dia`}
            </div>
            {!todosMode && (
              <div style={{ fontSize: '11px', color: '#333', marginTop: '4px' }}>
                Dias: {diasTrabalho.join(', ')}
              </div>
            )}
          </div>
        ) : horariosBarb.length === 0 ? (
          <div style={{ backgroundColor: '#181818', border: '0.5px solid #252525', borderRadius: '10px', padding: '20px', textAlign: 'center', marginBottom: '24px' }}>
            <div style={{ fontSize: '24px', marginBottom: '8px' }}>🌙</div>
            <div style={{ fontSize: '13px', color: '#8f8f8f' }}>Sem horários disponíveis neste dia</div>
          </div>
        ) : (
          <>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px', marginBottom: todosMode && horarioSelected && barbeiroAssigned ? '12px' : '28px' }}>
              {horariosBarb.map((h, i) => {
                const passado = isPastTime(h);
                let ocupado, indisponivel;
                if (todosMode) {
                  const disponiveis = getBarbeirosDisponiveis(h);
                  indisponivel = passado || disponiveis.length === 0;
                  ocupado = !passado && disponiveis.length === 0;
                } else {
                  ocupado = horariosOcupados.includes(h);
                  indisponivel = passado || ocupado;
                }
                const ativo = horarioSelected === h;
                return (
                  <div key={i}
                    onClick={() => !indisponivel && selecionarHorario(h)}
                    style={{
                      backgroundColor: indisponivel ? '#111' : ativo ? '#1a2a1a' : '#181818',
                      border: `0.5px solid ${indisponivel ? '#1a1a1a' : ativo ? '#3d6b3d' : '#252525'}`,
                      borderRadius: '8px', padding: '10px',
                      textAlign: 'center', fontSize: '12px',
                      color: indisponivel ? '#2a2a2a' : ativo ? '#7bc47b' : '#888',
                      cursor: indisponivel ? 'default' : 'pointer',
                      textDecoration: passado ? 'line-through' : 'none',
                      position: 'relative'
                    }}>
                    {h}
                    {ocupado && !passado && (
                      <div style={{ fontSize: '7px', color: '#333', marginTop: '2px' }}>ocupado</div>
                    )}
                  </div>
                );
              })}
            </div>
            {/* Indicador de barbeiro atribuído (modo todos) */}
            {todosMode && horarioSelected && barbeiroAssigned && (
              <div style={{
                display: 'flex', alignItems: 'center', gap: '8px',
                backgroundColor: '#141f14', border: '0.5px solid #2d4a2d',
                borderRadius: '10px', padding: '10px 14px', marginBottom: '28px'
              }}>
                <div style={{
                  width: '28px', height: '28px', borderRadius: '50%',
                  backgroundColor: '#1e2e1e', overflow: 'hidden', flexShrink: 0,
                  display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  {barbeiroAssigned.foto
                    ? <img src={barbeiroAssigned.foto} alt={barbeiroAssigned.nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={e => e.target.style.display='none'} />
                    : <span style={{ fontSize: '14px' }}>✂️</span>
                  }
                </div>
                <div>
                  <div style={{ fontSize: '11px', color: '#8f8f8f' }}>Barbeiro atribuído</div>
                  <div style={{ fontSize: '13px', color: '#7bc47b', fontWeight: '600' }}>{barbeiroAssigned.nome}</div>
                </div>
              </div>
            )}
          </>
        )}

        {/* Serviços */}
        <div ref={servicosRef} style={{ fontSize: '10px', letterSpacing: '2px', color: '#7d7d7d', textTransform: 'uppercase', marginBottom: '10px' }}>
          Escolha o serviço
        </div>
        {/* Banner desconto por dias — sempre visível quando ativa */}
        {promoDias.ativa && (
          <div style={{ backgroundColor: '#2a1a05', border: '0.5px solid #c9a84c', borderRadius: '8px', padding: '8px 12px', marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
              <span style={{ fontSize: '13px' }}>🏷️</span>
              <span style={{ fontSize: '12px', color: '#c9a84c', fontWeight: '600' }}>{promoDias.desconto}% de desconto em dias especiais</span>
            </div>
            <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
              {['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'].map((d, i) => {
                const temDesc = (promoDias.diasSemana || []).includes(i);
                return (
                  <span key={i} style={{
                    fontSize: '10px', padding: '2px 6px', borderRadius: '4px',
                    backgroundColor: temDesc ? 'rgba(201,168,76,0.15)' : '#111',
                    border: `0.5px solid ${temDesc ? '#c9a84c' : '#222'}`,
                    color: temDesc ? '#c9a84c' : '#444',
                    fontWeight: temDesc ? '700' : '400'
                  }}>{d}</span>
                );
              })}
            </div>
            {ehDiaEspecial && <div style={{ fontSize: '11px', color: '#7bc47b', marginTop: '5px' }}>✓ Desconto de {promoDias.desconto}% ativo para este dia!</div>}
            {promoDias.texto ? <div style={{ fontSize: '11px', color: '#8f8f8f', marginTop: '3px' }}>{promoDias.texto}</div> : null}
          </div>
        )}

        {/* Banner desconto simples — aparece quando ativo e o dia não tem desconto especial */}
        {promoSimples.ativa && !ehDiaEspecial && (
          <div style={{ display: 'flex', alignItems: 'center', gap: '6px', backgroundColor: '#2a1a05', border: '0.5px solid #c9a84c', borderRadius: '8px', padding: '6px 12px', marginBottom: '10px' }}>
            <span style={{ fontSize: '13px' }}>🏷️</span>
            <span style={{ fontSize: '12px', color: '#c9a84c', fontWeight: '600' }}>
              {promoSimples.desconto}% de desconto
              {promoDias.ativa ? ' nos demais dias' : ' em todos os serviços'}
            </span>
            {promoSimples.texto ? <span style={{ fontSize: '11px', color: '#aeaeae' }}>— {promoSimples.texto}</span> : null}
          </div>
        )}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '24px' }}>
          {servicos.map((s, i) => (
            <div key={i} onClick={() => setServicoSelected(i)} style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
              backgroundColor: servicoSelected === i ? '#1a2a1a' : '#181818',
              border: `0.5px solid ${servicoSelected === i ? '#3d6b3d' : '#252525'}`,
              borderRadius: '10px', padding: '12px 14px', cursor: 'pointer'
            }}>
              <div>
                <div style={{ fontSize: '13px', fontWeight: '500', color: '#ccc' }}>{s.nome}</div>
                {s.duracao && <div style={{ fontSize: '11px', color: '#8f8f8f', marginTop: '2px' }}>{s.duracao}</div>}
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <div style={{ textAlign: 'right' }}>
                  {desconto > 0 && (
                    <div style={{ fontSize: '10px', color: '#8f8f8f', textDecoration: 'line-through' }}>{s.precoOriginal}</div>
                  )}
                  <span style={{ fontSize: '13px', color: '#c9a84c', fontWeight: '600' }}>{s.preco}</span>
                </div>
                <div style={{
                  width: '18px', height: '18px', borderRadius: '50%',
                  border: `1.5px solid ${servicoSelected === i ? '#3d6b3d' : '#333'}`,
                  backgroundColor: servicoSelected === i ? '#2d4a2d' : 'transparent',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: '10px', color: '#7bc47b'
                }}>
                  {servicoSelected === i ? '✓' : ''}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Botão confirmar */}
        <button
          onClick={() => {
            if (!horarioSelected) { alert('Selecione um horário'); return; }
            if (todosMode && !barbeiroAssigned) { alert('Nenhum barbeiro disponível para este horário'); return; }
            onConfirmar({
              barbeiro: barbeiroParaConfirmar,
              servico: servicoAtual,
              horario: horarioSelected,
              dia: { num: diaSelected, mes: mesAtivo }
            });
          }}
          disabled={!barbeiroPodeHoje || !horarioSelected || (todosMode && !barbeiroAssigned)}
          style={{
            width: '100%',
            backgroundColor: (!barbeiroPodeHoje || !horarioSelected || (todosMode && !barbeiroAssigned)) ? '#1a1a1a' : '#2d4a2d',
            color: (!barbeiroPodeHoje || !horarioSelected || (todosMode && !barbeiroAssigned)) ? '#444' : '#7bc47b',
            border: 'none', borderRadius: '12px', padding: '16px',
            fontSize: '14px', fontWeight: '600',
            cursor: (!barbeiroPodeHoje || !horarioSelected || (todosMode && !barbeiroAssigned)) ? 'default' : 'pointer',
            letterSpacing: '0.5px', fontFamily: 'Arial, sans-serif',
            marginBottom: '32px'
          }}>
          {editando ? 'SALVAR ALTERAÇÕES' : 'CONFIRMAR AGENDAMENTO'}
        </button>
      </div>
    </div>
  );
}

export default Horarios;
